import tourAmericanFlat from '@/assets/img/users-cases/3D-tour-american-flat.webp';
import tourAmericanFlatHow from '@/assets/img/users-cases/3D-tour-american-flat-how.webp';
import tourAmericanFlatResult from '@/assets/img/users-cases/3D-tour-american-flat-result.webp';

export default {
  slug: '3D-tour-american-flat',
  order: 25,
  title: '3D Tour American Flat',
  subtitle: 'Creating an interactive 3D apartment experience for remote real estate buyers using AI floor plan technology.',
  tags: ['VirtualTour', 'RealEstate'],

  images: {
    hero: tourAmericanFlat,
    aboutTop: tourAmericanFlatHow,
    aboutBottom: tourAmericanFlatResult,
  },

  howText:
    'The team uploaded the apartment layout into the AI floor plan generator, allowing the software to automatically analyze and optimize the structure. A detailed 2D floor plan was generated, then converted into a fully furnished 3D floorplan, followed by a 360° virtual tour that was integrated into the online listing for immersive viewing.',

  resultText:
    'By using our AI floor plan to 3D model technology, the agency was able to provide buyers with a complete 2D floor plan for each level, a fully furnished 3D floorplan of the apartment, and a 360° virtual tour, enabling potential buyers to explore the space online and make informed decisions without visiting the property in person. This approach significantly increased engagement and accelerated remote sales.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
